export const uniqueId = () => {
  return `${Date.now().toString(36)}-${Math.random().toString().slice(2)}`;
};